import { AppPageLayout } from "@/components/common/AppPageLayout";
import { studyByIdQueryOptions } from "@/features/studies/api/selectStudies";
import { Outlet, createFileRoute } from "@tanstack/react-router";

function StudyIdLayout() {
    return (
        <AppPageLayout width="md" as="div">
            <Outlet />
        </AppPageLayout>
    );
}

export const Route = createFileRoute("/_app/studies/$studyId")({
    component: StudyIdLayout,
    loader: async ({ context, params }) => {
        try {
            await context.queryClient.ensureQueryData(studyByIdQueryOptions(params.studyId));
        } catch {
            // New study ids won't exist yet.
        }
    },
});
